enum ActivityControlBarTheme {
    Default = "default",
    Floating = "floating"
}

export default ActivityControlBarTheme;
